export default __webpack_public_path__ + "static/media/srednje.04fc2284.JPG";